import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BaseHandler } from '../../graphql-orchestrator-link';
import { GetProductCategoryAndKeywords } from '../../listing-services';
import SearchFilters from './Filters';
import { transposeProductTagsToFilters } from './utils/ProductTagsToFiltersTranspose';
import { SearchFilterTranspose } from './utils/SearchFilterTransposeUtil';
export class SearchFiltersHandler extends BaseHandler {
  async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
    const {
      showCompassApps,
      showTrelloProductFilter,
      stargateBaseUrl
    } = operation.variables;

    // HARD CODED FILTER OPTIONS
    const hardcodeResponse = SearchFilters({
      showCompassApps,
      showTrelloProductFilter
    });

    // PRODUCT TAGS API -- /api/public/v1/product-tags
    const serviceResponse = await GetProductCategoryAndKeywords({
      stargateBaseUrl
    });
    const productTags = transposeProductTagsToFilters({
      data: serviceResponse
    });

    // merge response
    const response = _objectSpread(_objectSpread({}, hardcodeResponse), productTags);
    return response;
  }
  responseTransformer(_operation, _transformedOperation, _sequenceConfigValue, _primaryResponse, customResponse) {
    const response = SearchFilterTranspose(customResponse);
    return response;
  }
}